module.exports = __webpack_public_path__ + "img/th_th.f973b3fa.png";